import { OptionGroup } from 'mol-ui';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

const GenderPicker = ({
    backgroundColor,
    disabled,
    fontSize,
    margin,
    onChange = () => null,
    value,
    width
}) => {
    
    const { overPrimaryColor } = useTheme();
    const { t } = useTranslation();
    const genderOptions = [{ label: t('Femenino'), value: 'Female' }, { label: t('Masculino'), value: 'Male' }];

    const commonProps = {
        backgroundColor: backgroundColor ?? overPrimaryColor,
        disabled,
        fontSize,
        margin,
        options: genderOptions,
        value,
        width
    };

    return (
        <OptionGroup
            { ...commonProps }
            onChange={ value => onChange(value)  }
        />
    );
};

GenderPicker.propTypes = {
    backgroundColor: PropTypes.string,
    disabled: PropTypes.bool,
    fontSize: PropTypes.string,
    margin: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOf(['Female', 'Male']),
    width: PropTypes.string
};

export default GenderPicker;
